import BaseURL from "./baseURL";

const userAPI = {
	REFERRAL_URL: `${BaseURL.LOCAL_BASE_URL}/user/referral`,
	LEADERBOARD_URL: `${BaseURL.LOCAL_BASE_URL}/user/leaderboard`,
};

export default userAPI;
